/* RESPONSIBLE TEAM: team-frontend-tech */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'qualification_attributes';
  },
});
